export const convertListStatusToEntityStatus = (
	status: string,
	customStatuses?: { status: string; label: "ACTIVE" | "DISABLED" | "WARNING" | "INFORMATION" }[]
) => {
	const customStatus = customStatuses?.find((customStatus) => customStatus.status === status);
	if (customStatus) {
		return customStatus.label;
	}

	switch (status) {
		case "RECEIVED":
		case "SHIPPED":
		case "ENABLED":
			return "ACTIVE";
		case "UNLINKED":
		case "PARTIALLY_RECEIVED":
		case "VOID":
		case "REVOKED":
		case "CLOSED":
		case "DELETED":
			return "DISABLED";
		case "DRAFT":
			return "WARNING";
		case "OPEN":
		case "PARTIALLY_SHIPPED":
			return "INFORMATION";
		default:
			return status;
	}
};
